export default class TimesheetsChangeLabelModel {
  constructor({
    icon = '',
    iconClass = 'primary--text mr-1',
    classList = 'primary--text',
    tooltip = '',
    text = '',
    isVisible = true,
  } = {}) {
    this.icon = icon

    this.iconClass = iconClass

    this.classList = classList

    this.tooltip = tooltip

    this.text = text

    this.isVisible = isVisible
  }
}
